import styled, { device } from "@styled";

export const SectionWrap = styled.div``;
export const ProgressCircleWrap = styled.div`
    margin-block-start: 30px;
`;
